import { push, replace } from '@takeshape/redux-little-router';
import { loginUser } from 'app/auth/actions';
import { handleRoutine } from 'app/common/utils/saga';
import { showMessage } from 'app/messages/actions';
import { SUBMIT_FORM } from 'app/schema-form/action-types';
import queryString from 'query-string';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getForm } from '../schema-form/index.js';
import { login } from './actions.js';
import { auth, claim } from './api.js';
import { CLAIM_PROJECT_FORM } from './constants.js';

export const claimFormSubmit = (action) =>
  action.type === `${SUBMIT_FORM}_SUCCESS` && action.meta.formName === CLAIM_PROJECT_FORM;

export function* projectClaimSaga() {
  const form = yield select(getForm, { formName: CLAIM_PROJECT_FORM });
  const data = form.get('data').toJS();
  yield call(claim, data);
  yield put(push(`/netlify-addon/check-email?${queryString.stringify({ email: data.email })}`));
}

export function* loginSaga(payload) {
  const { data } = yield call(auth, payload);
  if (data.projectUnclaimed) {
    const query = {
      token: data.token,
      siteName: data.siteName
    };
    yield put(replace(`/netlify-addon/claim?${queryString.stringify(query)}`));
  } else {
    yield put(loginUser.fulfilled({ data: data.user }));
    yield put(push(`/project/${data.projectId}`));
  }
}

export function* loginFailedSaga(action) {
  yield put(showMessage('error', `Netlify Auth Failed: ${action.payload.message}`));
  yield put(push('/login'));
}

export default function* root() {
  yield all([
    takeLatest(claimFormSubmit, projectClaimSaga),
    takeLatest(login.rejected, loginFailedSaga),
    handleRoutine(login, loginSaga, { handleBasicErrors: false })
  ]);
}
